// extracted by mini-css-extract-plugin
export default {"navigation-list":"Lrnxv","navigation-list__item":"cw0Dg","navigation-list__title":"chD0H","link__text":"GCMZb"};